import http from "@/helper/http";
import {BaseVO} from "@/model/global";
import {useMutation} from "@tanstack/react-query";
import {TaskReviewForm} from "@/widget/TaskReview/TaskReview";

export enum ReviewEnum {
    CreateReview = "/review/createReview",
}

export const useCreateReview = () => useMutation({
    mutationFn: (data: TaskReviewForm) => http.put<BaseVO<null>>({url: ReviewEnum.CreateReview, data}),
})




